module.exports = __webpack_public_path__ + "img/info_berhasil.db20dcbf.png";